import Status from './status';

export default class Analise {
  constructor(id='', descricao='', status, parecer, recurso, parecerDoRecurso, permiteParecer = false, permiteParecerDoRecurso = false) {
    this.id = id;
    this.descricao = descricao;
    this.status = new Status(status);
    this.parecer = parecer;
    this.recurso = recurso;
    this.parecerDoRecurso = parecerDoRecurso;
    this.permiteParecer = permiteParecer;
    this.permiteParecerDoRecurso = permiteParecerDoRecurso;
  }
}
